<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div
        class="absolute inset-0 z-10 overflow-hidden bg-zinc-200/40 dark:bg-zinc-900/60 backdrop-blur-md flex items-center justify-center">

        <button type="button" (click)="closeModal()" [disabled]="submitting()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>

        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="shrink-0 z-10 w-full h-full flex flex-col overflow-hidden">


                @if (step() === 'choose') {
                <!-- Hero -->
                <div
                    class="shrink-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
                    <div class="flex items-center">
                        <div class="shrink-0">
                            <div
                                class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path
                                        d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                                    <circle cx="12" cy="8" r="6" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <h3 class="text-base font-semibold text-gray-900 dark:text-white">Buy Ad License</h3>
                            <p class="text-sm text-gray-500 dark:text-gray-400">
                                An Ad License lets you boost a video on your own channels or run it as a dark ad for {{
                                quote().termDays }} days.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Hero  - END-->

                <!-- Body -->
                <div class="flex-1 flex flex-col w-full items-center justify-center overflow-hidden">
                    <div class="h-full w-full overflow-hidden grid grid-cols-3 gap-x-4 p-2">
                        <article
                            class="h-full flex flex-col col-span-1 gap-y-2 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                            <div class="w-full flex-1 overflow-hidden">
                                <div class="h-full w-full flex items-center justify-center">
                                    <atom-video-thumbnail class="block h-full w-full" [videoUrl]="video().fullUrl"
                                        [thumbnailURL]="thumbnailUrl()" [cdnKey]="thumbnailCdnKey()"
                                        [videoFormat]="video().videoFormat" [hideError]="true"></atom-video-thumbnail>
                                </div>
                            </div>
                            <div
                                class="w-full shrink-0 flex flex-col gap-0.5 rounded-lg bg-white shadow dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10 px-4 py-2">
                                <p class="m-0 text-sm font-semibold text-gray-900 dark:text-white">{{ draftLabel() }}
                                </p>
                                <p class="m-0 text-sm text-gray-500 dark:text-gray-400">{{ creatorFirstName() }}</p>
                            </div>
                        </article>
                        <article class="h-full flex flex-col col-span-2 overflow-hidden">
                            <div class="w-full flex-1 overflow-hidden">
                                <div class="h-full w-full overflow-y-auto scrollbar-transparent">
                                    <!-- Pricing Card -->
                                    <div
                                        class="w-full flex flex-row items-center justify-between rounded-lg bg-white shadow dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10 px-4 py-2">
                                        <div class="">
                                            <p class="mt-2 flex items-baseline gap-x-2">
                                                <span
                                                    class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                                    price() | currency: currencyCode() }}</span>
                                                <span class="text-sm text-gray-500 dark:text-gray-400">one-off</span>
                                            </p>
                                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Includes
                                                {{ vat()
                                                | currency: currencyCode() }} VAT</p>
                                        </div>
                                        <div class="text-right">
                                            <p class="mt-2 flex items-baseline justify-end gap-x-2">
                                                <span
                                                    class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                                    quote().termDays }}</span>
                                                <span class="text-sm text-gray-500 dark:text-gray-400">days</span>
                                            </p>
                                            <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">from
                                                creator
                                                approval</p>
                                        </div>
                                    </div>
                                    <!-- Pricing Card - END -->

                                    <!-- What you can do -->
                                    <div class="py-6">
                                        <div class="mx-auto max-w-7xl px-6 lg:px-8">
                                            <div class="mx-auto max-w-2xl text-center">
                                                <p
                                                    class="text-2xl font-semibold tracking-tight text-pretty text-gray-900 lg:text-balance dark:text-white">
                                                    What you can do</p>
                                                <p class="mt-1 text-md font-medium text-secondary">What does lincesing
                                                    this
                                                    content allow you to do?</p>
                                            </div>
                                            <div class="my-6 mx-auto max-w-2xl lg:max-w-none">
                                                <dl class="grid w-full grid-cols-2 gap-x-8">
                                                    @for (right of rights(); track right.key) {
                                                    <div class="flex flex-col">

                                                        <dt
                                                            class="flex items-center gap-x-3 text-md font-semibold text-primary">
                                                            <div
                                                                class="mb-2 flex size-10 items-center justify-center rounded-lg bg-[#F0E6FE] text-[#6508FB]">
                                                                @switch (right.icon) {
                                                                @case ('trending') {
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18"
                                                                    height="18" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round">
                                                                    <path d="M22 7 13.5 15.5 8.5 10.5 2 17" />
                                                                    <path d="M16 7h6v6" />
                                                                </svg>
                                                                }
                                                                @case ('target') {
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18"
                                                                    height="18" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <circle cx="12" cy="12" r="6" />
                                                                    <circle cx="12" cy="12" r="2" />
                                                                </svg>
                                                                }
                                                                @default {
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18"
                                                                    height="18" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round">
                                                                    <path d="m3 11 18-5v12L3 14v-3z" />
                                                                    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
                                                                </svg>
                                                                }
                                                                }
                                                            </div>
                                                            {{ right.title }}
                                                        </dt>
                                                        <dd class="mt-0 flex flex-auto flex-col text-sm text-secondary">
                                                            <p class="flex-auto">{{ right.description }}</p>
                                                        </dd>
                                                    </div>
                                                    }

                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- What you can do - END -->

                                    <!-- 3 Boxes -->
                                    <div class="py-6">
                                        <div class="mx-auto max-w-7xl px-6 lg:px-8">
                                            <div class="mx-auto max-w-2xl text-center">
                                                <p
                                                    class="text-2xl font-semibold tracking-tight text-pretty text-gray-900 lg:text-balance dark:text-white">
                                                    How it works</p>
                                            </div>
                                            <ol class="grid grid-cols-1 gap-2 sm:grid-cols-3 my-6">
                                                <li
                                                    class="rounded-lg border border-black/8 bg-[#FAFAFA] p-3 dark:border-white/10 dark:bg-zinc-800">
                                                    <p class="text-sm font-extrabold text-[#6508FB]">1</p>
                                                    <p class="mt-1 text-base font-bold leading-tight">You pay {{ price()
                                                        |
                                                        currency:
                                                        currencyCode() }} from
                                                        your wallet</p>
                                                </li>
                                                <li
                                                    class="rounded-lg border border-black/8 bg-[#FAFAFA] p-3 dark:border-white/10 dark:bg-zinc-800">
                                                    <p class="text-sm font-extrabold text-[#6508FB]">2</p>
                                                    <p class="mt-1 text-base font-bold leading-tight">{{
                                                        creatorFirstName() }}
                                                        approves
                                                        the license</p>
                                                </li>
                                                <li
                                                    class="rounded-lg border border-black/8 bg-[#FAFAFA] p-3 dark:border-white/10 dark:bg-zinc-800">
                                                    <p class="text-sm font-extrabold text-[#6508FB]">3</p>
                                                    <p class="mt-1 text-base font-bold leading-tight">Your {{
                                                        quote().termDays
                                                        }} days
                                                        begin</p>
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                    <!-- 3 Boxes - END -->

                                    <!-- Wallet -->
                                    <div class="py-6">
                                        <div class="mx-auto max-w-7xl px-6 lg:px-8">
                                            <div class="mx-auto max-w-2xl text-center">
                                                <p
                                                    class="text-2xl font-semibold tracking-tight text-pretty text-gray-900 lg:text-balance dark:text-white">
                                                    Wallet</p>
                                                <p class="mt-1 text-md font-medium text-secondary">The funds will be
                                                    reserved in your wallet until the license is approved or declined.
                                                </p>
                                            </div>
                                            <div
                                                class="my-6 w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow flex flex-col min-h-0 rounded-xl border border-border shadow-sm">
                                                <div
                                                    class="border-b border-gray-200 px-3 py-3 dark:border-white/10 shrink-0 bg-muted/50">
                                                    <div
                                                        class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                                                        <div class="flex flex-row items-center justify-start gap-x-2">

                                                            <div class="flex flex-col items-center justify-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18"
                                                                    height="18" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    aria-hidden="true" class="size-5 text-accent">
                                                                    <path
                                                                        d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
                                                                    <path
                                                                        d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
                                                                </svg>
                                                            </div>
                                                            <div class="flex flex-col">
                                                                <h3 class="text-sm font-semibold text-primary">Payment
                                                                    Details
                                                                </h3>
                                                                <p
                                                                    class="hidden sm:block mt-0.5 text-xs text-secondary">
                                                                    How
                                                                    will I
                                                                    be
                                                                    charged?</p>
                                                            </div>
                                                        </div>
                                                        <div class="shrink-0 flex flex-row items-center gap-x-2">
                                                            RHS
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex flex-col divide-y divide-gray-200">
                                                    <dl
                                                        class="w-full divide-y divide-gray-100 text-sm/6 dark:divide-white/10">
                                                        <div class="flex justify-between gap-x-4 py-3 px-6">
                                                            <dt class="text-gray-500 dark:text-gray-400">Current Wallet
                                                                Balance
                                                            </dt>
                                                            <dd class="text-gray-700 dark:text-gray-300">
                                                                @if (walletBalance() !== null) {
                                                                {{ walletBalance() | currency: currencyCode() }}
                                                                } @else {
                                                                —
                                                                }</dd>
                                                        </div>

                                                        <div class="flex justify-between gap-x-4 py-3 px-6">
                                                            <dt class="text-gray-500 dark:text-gray-400">After purchase
                                                            </dt>
                                                            @if (insufficientFunds()) {
                                                            <dd class="flex items-start gap-x-2">
                                                                <div class="font-medium text-gray-900 dark:text-white">
                                                                    Insufficient
                                                                    funds
                                                                </div>
                                                                <button type="button" (click)="openTopUp()"
                                                                    class="primary-button-small inline-flex items-center gap-x-2 transition-all ease-in-out duration-300">Top
                                                                    up
                                                                    wallet</button>
                                                            </dd>
                                                            } @else {
                                                            <dd class="flex items-start gap-x-2">
                                                                <div class="font-medium text-gray-900 dark:text-white">
                                                                    @if (balanceAfter() !== null) {
                                                                    {{ balanceAfter() | currency: currencyCode() }}
                                                                    } @else {
                                                                    —
                                                                    }
                                                                </div>
                                                                <div
                                                                    class="rounded-md bg-amber-50 px-2 py-1 text-xs font-medium text-amber-700 ring-1 ring-amber-600/10 ring-inset dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-500/10">
                                                                    Reserved</div>
                                                            </dd>
                                                            }
                                                        </div>
                                                    </dl>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Wallet - END -->

                                    <!-- Sub text -->
                                    <p class="my-6 text-md font-semibold leading-tight text-zinc-500 text-center">If {{
                                        creatorFirstName() }}
                                        declines or doesn't respond within {{ quote().responseDays }} days, the full {{
                                        price()
                                        | currency:
                                        currencyCode() }} goes straight back to your wallet.</p>
                                    <!-- Sub text - END -->
                                </div>
                            </div>
                            <div class="w-full shrink-0">
                                <!-- License Agreement -->

                                <div
                                    class="rounded-md bg-primary/10 p-4 dark:bg-primary/10 dark:outline dark:outline-primary/20">
                                    <div class="flex">
                                        <div class="shrink-0">
                                            <button type="button" role="checkbox" [attr.aria-checked]="agreed()"
                                                (click)="toggleAgreed()" aria-labelledby="ad-license-terms-label"
                                                class="flex size-[22px] shrink-0 items-center justify-center rounded-[5px] text-white"
                                                [class]="agreed() ? 'bg-[#6508FB]' : 'border-[1.5px] border-black/28 dark:border-white/40'">
                                                @if (agreed()) {
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"
                                                    aria-hidden="true">
                                                    <path d="M20 6 9 17l-5-5" />
                                                </svg>
                                                }
                                            </button>
                                        </div>
                                        <div class="ml-3 flex-1 md:flex md:justify-between">
                                            <p class="text-md text-accent">I agree to
                                                the <a [href]="termsUrl" target="_blank" rel="noopener"
                                                    (click)="onTermsClick($event)"
                                                    class="font-extrabold text-accent underline underline-offset-2">Ad
                                                    License
                                                    terms</a></p>

                                        </div>
                                    </div>
                                </div>
                                <!-- License Agreement - END -->
                            </div>
                        </article>
                    </div>
                </div>
                <!-- Body - END-->

                <!-- Footer -->
                <div
                    class="shrink-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
                    <button (click)="closeModal()" [disabled]="submitting()" type="button"
                        class="secondary-button text-primary inline-flex flex-row items-center">
                        Cancel
                    </button>

                    @if (submitting()) {
                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                        <svg aria-hidden="true"
                            class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>

                        Sending License Request...
                    </span>
                    } @else {
                    <button (click)="submit()" [disabled]="!canSubmit()" [attr.aria-busy]="submitting()" type="button"
                        class="primary-button inline-flex flex-row items-center gap-x-2 disabled:opacity-60 disabled:cursor-not-allowed">
                        Pay {{ price() | currency: currencyCode() }} &amp; Request License
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                            <path d="m21.854 2.147-10.94 10.939" />
                        </svg>
                    </button>
                    }
                </div>
                <!-- Footer - END-->
                } @else {

                <!-- Hero -->
                <div
                    class="shrink-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
                    <div class="flex items-center">
                        <div class="shrink-0">
                            <div
                                class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path
                                        d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                                    <circle cx="12" cy="8" r="6" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <h3 class="text-base font-semibold text-gray-900 dark:text-white">Buy Ad License</h3>
                            <p class="text-sm text-gray-500 dark:text-gray-400">
                                An Ad License lets you boost a video on your own channels or run it as a dark ad for {{
                                quote().termDays }} days.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Hero  - END-->

                <div class="flex-1 flex flex-col w-full items-center justify-center overflow-hidden">
                    <div class="h-full w-full overflow-hidden flex flex-col items-center justify-center">
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m16 9-5.5 5.5L8 12" />
                            </svg>

                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">License Requested</h3>
                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">We've sent
                                your request to {{ creatorFirstName() }}. Your {{ quote().termDays }} days start the
                                moment they approve,
                                and we'll notify you when it's live.</p>
                            <div class="mt-6">
                                <button type="button" (click)="closeModal()"
                                    class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="mr-1.5 -ml-0.5 size-5">
                                        <path
                                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                    </svg>
                                    Done
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                }


            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>
        </div>
    </div>
</div>